export const getUrlPath = () => {
    let preset;
    try {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        preset = pathParts[pathParts.length - 1] || 'default';

    } catch (e) { }

    return preset
}


export const getPreset = (preset) => {
    if (!preset)
        preset = getUrlPath()
    switch (preset) {
        case 'report':
            return '&column[]=id&column[]=name&column[]=alias&column[]=mute&column[]=address&column[]=msstatus_id&column[]=lastsyncsystem&column[]=lastsync&column[]=lip&column[]=lasterror&column[]=startsync'
        case 'advert':
            return '&column[]=id&column[]=name&column[]=alias&column[]=mute&column[]=address&column[]=msstatus_id'
        case 'object':
            return '&column[]=id&column[]=name&column[]=alias&column[]=mute&column[]=address&column[]=msstatus_id'
        default:
            return '';
    }
}